import { AxiosError } from 'axios';

import { ZEE_FINANCIAL_API_URL } from '@/constants/apis';
import { apiManager } from '@/helpers/api.manager';
import { ApiResponse } from '@/types/response.type';
import { LeadFinancial, LeadOtherFinancial } from '@/types/zee-candidate.type';

export type GetLeadFinancialApiResponse = {
  zee_financial: LeadFinancial;
  zee_other_financial: LeadOtherFinancial;
};

export const getLeadFinancial = async (
  candidateId: string
): Promise<ApiResponse<GetLeadFinancialApiResponse>> => {
  try {
    const response = await apiManager.get(
      `${ZEE_FINANCIAL_API_URL}/${candidateId}`,
      {
        headers: { 'Content-Type': 'application/json' },
      }
    );

    if (response.status !== 200) {
      const error = response as unknown as AxiosError;
      return Promise.reject(error.response?.data);
    }

    return Promise.resolve(response.data);
  } catch (e) {
    return Promise.reject(e);
  }
};
